class TextManager {
  /**
   * @description
   * Converts the string to capitalize
   * @param text the string to capitalize the text
   */
  static toCapitalize (text) {
    return text.charAt(0).toUpperCase() + text.slice(1)
  }

  /**
   * @description
   * Converts the string snake_case to Title Case
   * @param text string to be transformed
   * @param splitString String break point @default _
   */
  static convertSnakeToTitle (text, splitString = '_') {
    const ans = text.toLowerCase()
    return ans
      .split(splitString)
      .reduce((s, c) => this.toCapitalize(s) + ' ' + this.toCapitalize(c))
  }

  /**
   * @description
   * Converts the string camelCase to Title Case
   * @param text string to be transformed
   */
  static convertCamelToTitle (text) {
    const capitalizedWords = text.replace(/([A-Z])/g, ' $1')
    return this.toCapitalize(capitalizedWords)
  }

  /**
   * @description
   * Converts the string kebabCase to camelCase
   * @param text string to be transformed
   */
  static convertKebabCaseToCamelCase (text) {
    return text.replace(/-([a-z])/g, g => g[1].toUpperCase())
  }

  /**
   * @description
   * Converts the string kebabCase to TitleCase
   * @param text string to be transformed
   */
  static convertKebabCaseToTitle (text) {
    return this.convertCamelToTitle(this.convertKebabCaseToCamelCase(text))
  }

  /**
   * @description
   * Return a boolean if the param is snake_case
   * @param text string to be transformed
   */
  static isSnakeCase (text) {
    return text.includes('_')
  }

  /**
   * @description
   * Check if it is snake_case or camelCase and trasnform in Title Case
   * @param text string to be transformed
   */
  static formatTextSnakeOrCamel (text) {
    if (TextManager.isSnakeCase(text)) {
      return TextManager.convertSnakeToTitle(text)
    }
    return TextManager.convertCamelToTitle(text)
  }

  /**
   * @description
   * Return a boolean if the param is Lower Case
   * @param text string to be transformed
   */
  static isLowerCase (text) {
    return !/[A-Z]/.test(text)
  }

  /**
   * @description
   * Replace all characters of the string
   * @param str string to be replaced
   * @param mapObj  object with pairs key:value to replace
   */
  static replaceAllValuesObject (str, mapObj) {
    if (typeof str !== 'string') return str
    const re = new RegExp(Object.keys(mapObj).join('|'), 'gi')
    return str.replace(re, matched => mapObj[matched.toLowerCase()])
  }

  /**
   * @description
   * Convert text to a maximum size by adding ellipsis as a pattern to the end of your text
   * @param text string to be transformed
   * @param maxLength Maximum text size @default 0
   * @param eliipsis Text that will be used at the end @default ...
   */

  static textToEllipsis (text, maxLength = 0, eliipsis = '...') {
    if (!text) {
      throw new Error('Text is missing')
    }
    return text.substring(0, maxLength) + eliipsis
  }
}

export default TextManager
